import { from, lastValueFrom, map, switchMap } from "rxjs";
import { singleton } from "tsyringe";

import { AjaxApiCartApiService } from "../api_services/AjaxApiCartApiService/AjaxApiCartApiService";
import CartEntity from "../entities/CartEntity";
import { CartRepositoryInterface } from "./CartRepositoryInterface";

@singleton()
export class AjaxApiRepository implements CartRepositoryInterface {
    public constructor(
        private readonly ajaxApiCartApiService: AjaxApiCartApiService
    ) {}
    public async getCart(): Promise<{ cart: CartEntity }> {
        const cart = await lastValueFrom(this.ajaxApiCartApiService.getCart());
        return { cart };
    }
    public async addToCart(params: {
        items: { variantID: number; quantity: number }[];
        sections?: string[];
    }): Promise<{
        cart: CartEntity;
        sections?: Record<string, string | null>;
    }> {
        const { cart } = await lastValueFrom(
            this.ajaxApiCartApiService
                .addToCart({
                    items: params.items,
                    sections: params.sections || [],
                })
                .pipe(
                    switchMap((response) => {
                        return from(this.getCart()).pipe(
                            map(({ cart }) => {
                                return { cart, sections: response.sections };
                            })
                        );
                    })
                )
        );
        return {
            cart,
        };
    }
}
